import React from "react";
import "./CanaanTopProducts.css";

import ProductImage1 from "../../../../assets/Canaan/AvalonMinerA1366I-122T.png"; // Import your images here
import ProductImage2 from "../../../../assets/Canaan/Canaan-Product2.png";
import ProductImage3 from "../../../../assets/Canaan/Canaan-Product2.png";
import ProductImage4 from "../../../../assets/Canaan/Canaan-Product2.png";
import ProductImage5 from "../../../../assets/Canaan/Canaan-Product2.png";

const products = [
  { name: "Avalon Miner A1366I-122T", price: "25 990 SEK" },
  { name: "Avalon Miner A1326-115T", price: "19 990 SEK" },
  { name: "Avalon Miner A1326-112T", price: "19 495 SEK" },
  { name: "Avalon Miner A1326-106T", price: "17 990 SEK" },
  { name: "Avalon Miner A1326-103T", price: "17 495 SEK" },
];

const images = [
  ProductImage1,
  ProductImage2,
  ProductImage3,
  ProductImage4,
  ProductImage5,
];

const CanaanTopProductComponent = () => {
  return (
    <div className="mine-thunder-canaan-avalon-products-container">
      <h2 className="mine-thunder-canaan-avalon-products-title">
        New Products
      </h2>
      <h1 className="mine-thunder-canaan-avalon-products-big-title">
        Avalon Made
      </h1>
      <div className="mine-thunder-canaan-avalon-products">
        {products.map((product, index) => (
          <div
            className={`mine-thunder-canaan-avalon-product-${index + 1}`}
            key={index}
          >
            <div className="product-container">
              <img
                src={images[index]}
                alt={`Product ${index + 1}`}
                className="mine-thunder-canaan-product-image"
              />
              <div className="product-details">
                <h3 className="mine-thunder-canaan-product-title">
                  {product.name}
                </h3>
                <p className="mine-thunder-canaan-product-price">
                  Price: {product.price}
                </p>
                <a
                  href={`link-to-${product.name}`}
                  className="mine-thunder-canaan-view-details"
                >
                  View Details
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
      <a
        href="/canaan"
        className="mine-thunder-canaan-See-More-Products-Canaan"
      >
        See More Products
      </a>
    </div>
  );
};

export default CanaanTopProductComponent;
